<template>
  <main id="main-container">
    <Hero title="Panel General" page="Dispositivos por Empresa" />

    <div class="content">
      <div v-if="$store.state.devices.length == 0" class="row">
        <Card title="Sin Dispositivos">
           <p>No hay dispositivos disponibles en su cuenta.</p>
           <router-link :to="{ name: 'devices' }" class="btn btn-info">Crear Dispositivo</router-link>
        </Card>
      </div>

      <div v-for="(devices, companyName) in groupedDevices" :key="companyName" class="mb-5">
        
        <Card :title="companyName === 'Sin Empresa' ? 'Dispositivos Independientes' : 'Empresa: ' + companyName">
          
          <div class="row">
            <div v-for="device in devices" :key="device._id" class="col-12 mb-4">
              
              <div class="block block-rounded block-bordered border-start border-4 border-primary">
                <div class="block-header block-header-default bg-light">
                  <h3 class="block-title">
                    <i class="fa fa-microchip me-2 text-muted"></i>
                    {{ device.name }} 
                    <small class="ms-2 text-muted">({{ device.dId }})</small>
                  </h3>                  
                </div>

                <div class="block-content pb-3">
                  <div class="row">
                    <div v-if="device.template.widgets.length == 0" class="col-12 text-center py-4">
                      <p class="text-muted italic">Sin widgets configurados para este dispositivo.</p>
                    </div>

                    <div
                      v-for="(widget, idx) in device.template.widgets"
                      :key="idx"
                      class = "col-md-4 col-12"
                      :id="widget.variableFullName"

                    >
                      <component 
                        :is="getWidgetComponent(widget.widget)" 
                        :config="fixWidgetForDevice(widget, device)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </Card>
        </div>
    </div>
  </main>
</template>

<script>
import {
  Iotindicatorvalue,
  Rtnumberchart,
  Iotbutton,
  SetValueIndicator,
  Iotswitch,
  Iotindicator,
  OpenStreetMaps,
  IotSlider,
  FluidLevelIndicator,
} from "@/components/Widgets/index";
import emitter from "@/eventBus";

export default {
  name: "AllDevicesDashboard",
  components: {
    Rtnumberchart,
    Iotindicatorvalue,
    Iotbutton,
    SetValueIndicator,
    Iotswitch,
    Iotindicator,
    OpenStreetMaps,
    IotSlider,
    FluidLevelIndicator,
  },
  computed: {
    // Reutilizamos la lógica de agrupación vinculada a las empresas del usuario
    groupedDevices() {
      const groups = {};
      const assignedIds = new Set();
      const companies = this.$store.state.companies || []; // Asegúrate de tener las empresas en el store
      
      companies.forEach(company => {
        groups[company.name] = [];
        company.devices.forEach(dId => {
          const dev = this.$store.state.devices.find(d => d._id === dId);
          if (dev) {
            groups[company.name].push(dev);
            assignedIds.add(dev._id);
          }
        });
      });

      const orphans = this.$store.state.devices.filter(d => !assignedIds.has(d._id));
      if (orphans.length > 0) groups['Sin Empresa'] = orphans;

      return groups;
    }
  },
  mounted() {
    if (this.$store.state.mqtt_connected){
      this.get_mqtt_data_now("")
    }else {
      emitter.on("connected-mqtt", this.get_mqtt_data_now);
    }
  },

  unmounted(){
    emitter.on("connected-mqtt", this.get_mqtt_data_now);
  },
  
  methods: {
    // Determina qué componente cargar
    getWidgetComponent(widgetType) {
      const componentsMap = {
        'fluidLevel': 'Iotindicatorvalue',
        'slider': 'Iotindicatorvalue',
        'numberchart': 'Iotindicatorvalue',
        'indicatorvalue': 'Iotindicatorvalue',
        'button': 'Iotbutton',
        'setIndicator': 'Iotindicatorvalue',
        'switch': 'Iotswitch',
        'indicator': 'Iotindicator',
        'open-streetmaps': 'OpenStreetMaps'
      };
      return componentsMap[widgetType];
    },

    get_mqtt_data_now(msg) {

      setTimeout(() => {
        this.$store.state.devices.forEach( device => {
            const to_send = {
              msg,
              topic: `${this.$store.state.auth.userData._id}/${device.dId}/status/actdata`
          }  
          emitter.emit("mqtt-sender", to_send)
        })
        
      }, 1000)
    },
    // Adaptamos el widget al dispositivo específico (no al seleccionado globalmente)
    fixWidgetForDevice(widget, device) {
      let widgetCopy = JSON.parse(JSON.stringify(widget));
      widgetCopy.selectedDevice = {
        dId: device.dId,
        name: device.name
      };
      widgetCopy.userId = device.userId;
      if (widget.widget == "numberchart") {
        widgetCopy.demo = false;
      }
      return widgetCopy;
    }
  }
};
</script>

<style scoped>
.block-bordered {
  border: 1px solid #ebebeb;
}
.border-primary {
  border-left-color: #0665d0 !important;
}
</style>